import { render, staticRenderFns } from "./CreateVirtualDomainModal.vue?vue&type=template&id=00c9f19a&"
import script from "./CreateVirtualDomainModal.vue?vue&type=script&lang=js&"
export * from "./CreateVirtualDomainModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports